import axios from 'axios';
// console.log('Base URL:', process.env.REACT_APP_BASE_URL);
export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // timeout: 10000,
  // headers: {
  //   'Content-Type': 'application/json',
  //   withCredentials: true,
  // },
});

axiosInstance.interceptors.request.use(config => {
  // config.headers.Authorization = 'Bearer ' + getStoredToken();
  // config.headers.Authorization = 'Basic ' + getStoredToken();
  // config.headers.Authorization = 'Basic' + getStoredToken();
  // if(config?.data instanceof FormData) {
  //   config.headers['Content-Type'] = 'multipart/form-data';
  // }
  return config;
});

axiosInstance.interceptors.response.use(null, err => {
  // console.log('interceptors err:', err);
  // console.log('interceptors 222222:', err?.response);
  // console.log('interceptors 44444:', err?.config);
  // const statusCode = err.response.status;
  // if (statusCode === 401) {
  //   store.dispatch(clearUser());
  //   const navigator = useNavigate();
  //   navigator('/login');
  // }
  return err;
});
